module.exports = __webpack_public_path__ + "img/Ecobank Nigeria.b329eda4.png";